import { AdditionalInfoTabItem, AdditionalInfoTabType } from './types';

export const additionalInfoTabList: AdditionalInfoTabItem[] = [
  { label: 'Overview', value: AdditionalInfoTabType.OVERVIEW, icon: 'info' },
  { label: 'Commodity Connections', value: AdditionalInfoTabType.COMMODITY_CONNECTIONS, icon: 'chart-network' },
  // { label: 'History', value: AdditionalInfoTabType.HISTORY, icon: 'clock-rotate-left' }, ToDo: History Tab will be added later.
  { label: 'Drawings', value: AdditionalInfoTabType.DRAWINGS, icon: 'compass-drafting' },
];
